<template>



		<div class="modal modal-active">
			<div class="modal-dialog">
				 <div class="modal-content">
					 <div class="modal-header">
						 <div class="modal-title">{{ _lang('Configure domain')}}</div>
						 <span class="close" @click="close">&times;</span>
					</div>
					 <div class="modal-body">

							<div class="form-group">
									{{ _lang('Domain')}}:
									<div v-if="project.meta && project.meta.verified">
										{{domain}}
										<button class="btn btn-link btn-sm" @click="project.meta.verified = false">{{ _lang('Change')}}</button>
										<button class="btn btn-danger btn-sm" v-if="domain" @click="openModalRemoveDomain">{{ _lang('Remove')}}</button>

										<div v-if="dnsResponse" class="alert alert-success">{{ _lang('Your domain is successfully verified!')}}</div>
										<div class="mt-2">
											<button v-if="!isDeploying" class="btn btn-primary" @click="publish">{{ _lang('Deploy')}}!</button>
											<button v-if="isAdmin && !isDeploying" class="btn btn-primary" @click="publish_v2">{{ _lang('Deploy shell')}}</button>
										</div>
										<div class="mt-2" v-if="project.meta.deployv2">
											<p><small class="text-muted">{{ _lang('Deploy v2 enabled')}}</small></p>
											<details class="mt-1">
												<summary class="text-muted small" style="cursor: pointer;">{{ _lang('Advanced options')}}</summary>
												<div class="mt-2 pl-3">
													<label class="text-muted small"><input type="checkbox" v-model="shouldUpdateVercel"> {{ _lang('Force update')}}</label>
												</div>
											</details>
										</div>

										<div v-if="isDeploying">
											<progress />
											<p>{{deployMessages[deployMessageIndex]}}...</p>
										</div>

										<div class="form-group mt-2" v-if="publishResponse">
												<label>{{ _lang('Response')}}:</label>
												<div class="alert alert-info">{{publishResponse}}</div>
										</div>

										<a v-if="showlink" :href="deployUrl" class="btn btn-success mt-2" target="_blank">{{deployUrl}}</a>


									</div>
									<div v-else class="d-flex">
										<input type="text" class="form-control" v-model="domain" @keypress.enter="verifyCname">
										<button v-if="!isVerifying" class="btn btn-primary ml-1" @click.prevent="verifyCname">{{ _lang('Verify')}}</button>
									</div>
							</div>


							<div v-if="!project.meta || !project.meta.verified">

								<span v-if="isVerifying">
									<progress />
								</span>

								<div class="form-group mt-2" v-if="dnsResponse">
										<label>{{ _lang('Response')}}:</label>
										<div class="alert alert-warning">{{dnsResponse}}</div>
								</div>

								<div class="form-group mt-2">
										<label>{{ _lang('Instructions')}}:</label>
										<p>
											{{_lang('Set domain\'s DNS records to')}} <strong>76.76.21.21</strong><br>
											{{_lang('If you\'re using Cloudflare, set proxy to off')}}.
										</p>
								</div>

							</div>


					 </div>
				 </div>
			 </div>


			 <ModalRemoveDomain  v-if="modalRemoveDomain" :project="project" />


		</div>


</template>

<script>
import axios from 'axios';
import ModalRemoveDomain from '../components/ModalRemoveDomain.vue'
export default {
		props:['project','active'],
		components:{
			ModalRemoveDomain,
		},
		data(){
				return {
						domain:'',
						dnsResponse:'',
						publishResponse:'',
						showlink:false,
						modalRemoveDomain:false,
						isVerifying:false,
						isDeploying:false,
						deployExpectedTime:10,
						deployMessages:[
							'connecting deploy server',
							'converting links',
							'uploading assets',
							'optimizing',
						],
						deployMessageIndex:0,
						shouldUpdateVercel:false,
				}
		},
		computed:{
			msEach(){
				return this.deployExpectedTime/this.deployMessages.length * 1000;
			},
			deployUrl(){
				return 'https://'+this.domain;
			},
			isAdmin(){
				return this.$store.getters.user.is_admin;
			},
		},
		methods:{
			openModalRemoveDomain(){
				this.modalRemoveDomain = true;
			},

				close(){
						this.$emit('close');
				},
				updateDeployProgress(){
					setTimeout(()=>{
						if(this.deployMessageIndex>=this.deployMessages.length-1) return;
						this.deployMessageIndex++;
						this.updateDeployProgress();
					},this.msEach);
				},
		publish(){

			this.publishResponse = '';

			this.deployMessageIndex = 0;
			this.updateDeployProgress();
			this.isDeploying = true;
			this.showlink = false;

			axios({
				method: 'post',
				url: '/api/publish/'+this.project.id,
				data: {
					shouldUpdateVercel: this.shouldUpdateVercel
				}
			}).then((res) => {
				//this.publishResponse = res.data;
				this.isDeploying = false;
				this.showlink = true;
			}).catch(err=>{
				this.isDeploying = false;
				this.publishResponse = JSON.stringify(err.response);
			});



		},

		publish_v2(){
			this.publishResponse = '';
			this.deployMessageIndex = 0;
			this.updateDeployProgress();
			this.isDeploying = true;
			this.showlink = false;

			axios({
				method: 'post',
				url: '/api/publish_v2/'+this.project.id,
				data:{
					project_id:this.project.id,
					token:this.project.token,
				}
			}).then((res) => {
				//this.publishResponse = res.data;
				this.isDeploying = false;
				this.showlink = true;
			}).catch(err=>{
				this.isDeploying = false;
				this.publishResponse = JSON.stringify(err.response);
			});

		},


		verifyCname(){
				if(!this.domain.match(/^[a-z0-9-]+\.[a-z0-9-]+(\.[a-z0-9-]+)*$/)){
						this.dnsResponse = 'invalid domain';
						return;
				}
			this.dnsResponse = '';
			this.isVerifying = true;
			axios({
				method: 'post',
				url: '/api/dns-verify',
				data: {
					project_id:this.project.id,
					domain:this.domain,
				}
			}).then((res) => {
				this.dnsResponse = res.data;
				this.isVerifying = false;
				if(res.data.match(/76\.76\.21\.21|an alias for cname\.themedeploy\.com/m)){
					this.setVerified(this.domain);
				}
			}).catch(err=>{
				this.isVerifying = false;
				if(err.response.data){
					this.dnsResponse = err.response.data;
				} else {
					this.dnsResponse = JSON.stringify(err.response);
				}

			});
		},
		setVerified(domain){
			if(!this.project.meta || this.project.meta.length==0){
				this.project.meta = {};
			}
			this.project.domain = domain;
			this.project.meta.verified = true;
			this.project.meta.verifiedDomain = true;
			this.project.meta.verifiedTimestamp = new Date().getTime();
			axios({
				method: 'post',
				url: '/api/projects/'+this.project.id,
				data: this.project
			}).then((res) => {
				this.$emit('update');
			}).catch(err=>{
				if(err.response.data){
					this.dnsResponse = err.response.data;
				} else {
					this.dnsResponse = JSON.stringify(err.response);
				}
				this.project.meta.verified = false;
				this.project.meta.verifiedDomain = false;

			});

		},
		},
		mounted(){
				this.domain = this.project.domain;

		},


}
</script>

<style scoped>

</style>
